module.exports = __webpack_public_path__ + "assets/images/44059d2862b5ae58025354bd04312e2a.png";